import { $http } from '@/libs/ajax'
import taskJson from '@/mock/task.json'

export const listData = (params, cb, error) => {
    $http.post('/userTask/index', {}, {}).then(({ data }) => {
        if (!data.ret_code) {
            let res = {}
            res.typeList = []
            res.allTasks = {}
            res.typeTasks = {}
            data.ret.userTasks.forEach(function (element) {
                res.typeTasks[element.type] = element.tasks.map((_element) => {
                    _element.log.detail.items.forEach((__element) => {
                        _element.items[__element.index - 1].beActived = true
                    })
                    let showBtn = !!_element.url || _element.log.status !== 'TASKING'
                    let showCountStr = _element.type === 'ACHIEVEMENT' ? _element.log.status === 'TASKING' : !!_element.log.completeTitle
                    let obj = {
                        id: _element.log.id,
                        code: _element.code,
                        type: _element.type,
                        title: _element.name,
                        coins: _element.coinsValue,
                        maxCoins: _element.rCoinsValue,
                        iconUrl: _element.icon,
                        addExper: null,
                        note: _element.note,
                        hasNextTask: _element.hasNextTask,
                        countStr: showCountStr ? _element.log.completeTitle : null,
                        star: {
                            num1: _element.log.star,
                            num2: _element.maxStar - _element.log.star,
                            show: _element.showStar
                        },
                        btn: {
                            url: _element.url,
                            status: _element.log.status,
                            show: showBtn
                        },
                        details: _element.items,
                        show: true
                    }
                    res.allTasks[_element.code] = obj
                    return obj
                })
                delete element.tasks
                res.typeList.push(element)
            }, this)

            res.userInfo = {
                name: data.ret.user.name,
                isVip: data.ret.user.memberType === 'VIP',
                avatarUrl: data.ret.user.avatarUrl || (require('@/assets/img/task/photo@2x.png')),
                level: data.ret.honor.level,
                coins: data.ret.honor.coins,
                growth: data.ret.honor.growth,
                growthEnd: data.ret.honor.growth + data.ret.honor.upNeedGrowth,
                star: data.ret.starTreasure.star
            }
            res.chest = data.ret.starTreasure.starLevels
            res.showNewUserReward = data.ret.showNewUserReward
            // console.log(res.showNewUserReward)
            cb(res)
        } else {
            error(data)
        }
    })
}

export const helpData = (params, cb, error) => {
    $http.post('/userTask/spec', {}, {
        params
    }).then(({ data }) => {
        if (!data.ret_code) {
            let res = {}
            res.typeList = []
            res.helpInfo = taskJson.taskHelp[params.module]
            res.allTasks = {}
            res.typeTasks = {}
            data.ret.forEach(function (element) {
                res.typeTasks[element.type] = element.tasks.map((_element) => {
                    let obj = {
                        code: _element.code,
                        type: _element.type,
                        title: _element.name,
                        coinsValueTitle: _element.coinsValueTitle,
                        growthValueTitle: _element.growthValueTitle,
                        coinsNote: _element.coinsNote,
                        growthNote: _element.growthNote
                    }
                    res.allTasks[_element.code] = obj
                    return obj
                })
                delete element.tasks
                res.typeList.push(element)
            }, this)
            cb(res)
        } else {
            error(data)
        }
    })
}

export const exper = (params, cb, error) => {
    $http.post('/userTask/getReward', {}, {
        params
    }).then(({ data }) => {
        if (!data.ret_code) {
            // 字段有可能不存在 -- ！
            data.ret = data.ret || {}
            data.ret.tcode = params.id
            cb(data.ret)
        } else {
            error(data)
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/task.js